import React from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { TableCell } from 'semantic-ui-react';
import { format } from 'date-fns';

import { AppState } from 'services/types';
import { SprayEventForSubmission } from 'services/sprayEventsForSubmission/types';
import { makeSelectSprayEventForSubmissionStartDate } from 'services/sprayEventsForSubmission/selectors';

export interface OwnProps {
    sprayEventId: SprayEventForSubmission['id'];
}

interface ConnectedProps {
    sprayEventDate?: ReturnType<ReturnType<typeof makeSelectSprayEventForSubmissionStartDate>>;
}

type Props = OwnProps & ConnectedProps;

export class RenderSubmissionSprayEventsTableRowDateCellComponent extends React.PureComponent<
    Props
> {
    render(): React.ReactElement {
        const { sprayEventDate } = this.props;

        const date =
            sprayEventDate && format(new Date(sprayEventDate), 'dd/MM/yyyy');

        return (
            <TableCell textAlign="left" className="events-table-cell-padding">
                {date}
            </TableCell>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    sprayEventDate: makeSelectSprayEventForSubmissionStartDate()
});

export default connect(mapStateToProps)(
    RenderSubmissionSprayEventsTableRowDateCellComponent
);
